// Library Class
import * as $ from 'jquery';
import { Component, OnInit, AfterViewInit, OnDestroy, HostListener } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
// Class
import { DashboardFilter } from '../../../../../app/models/DashboardFilter';
import { MasterConstants } from '../../../../../app/common/constants/master-constants';
import { LicensingItemsFilter } from '../../../../../app/models/Licensing/LicensingItemsFilter';
// Service Class
import { LicensingService } from './../../../../services/seed/licensing.service';
import { AddUpdateLicenseSliderModelService } from '../add-update-license/add-update-license-slider-model.service';
import { LoaderService } from '../../../../../app/services/infrastructure/loader.service';
import { LocalStorageService } from '../../../../../app/services/infrastructure/local-storage.service';
import { Subscription } from 'rxjs';
import { LolLoggerService } from '../../../../common/shared/lol-logger.service';
import { CommonService } from '../../../../services/common/common.service';
import { MessageConfigurationVM } from '../../../../models/MessageConfigurationVM';

@Component({
  selector: 'app-licensing-dashboard',
  templateUrl: './licensing-dashboard.component.html',
  styleUrls: ['./licensing-dashboard.component.scss']
})
export class LicensingDashboardComponent implements OnInit, AfterViewInit, OnDestroy {
  private subscription = new Array<Subscription>();

  dashboardFilter: DashboardFilter;
  productFilters: any;
  filterValueList = new Array();
  public licensingList: any[] = [];
  public gmkList: any[] = [];
  public vendorMasterList: any[] = [];
  public growerCount = 0;

  headerYear: any;
  isEvolveAccountRestriction = false;
  showAllLicences = false;
  licensingFilter: LicensingItemsFilter = new LicensingItemsFilter();
  selectedValue: string;
  searchTypeList: string[] = [];
  accountStateList: any = [];
  districtMasterList: any = [];
  growerNameList: any = [];
  growerStateList: any = [];
  licenseStatusList: any = [];
  accountsList: any = [];
  traitManufacturerList: any = [];
  selList: any = [];
  displayedColumns: string[] = ['licenseStatus', 'manufacturer', 'licenseNumber'];
  unlicensedCount: number;
  unauthorizedCount: number;

  readOnlyAccess = false;
  userMenuAccessList: any;
  selectedGMK: any;
  orderDetail: any[] = [];
  redirectFromAddUpdate = false;
  licensePageWIPMsg = "";
  impDisplayName: any;
  private hasDeepLinkFilters = false;
  private deepLinkGrowerOrderNumber: string = null;
  private deepLinkGrowerName: string = null;
  private deepLinkLicenseStatus: string = null;

  constructor(private loaderService: LoaderService,
    private localStorageService: LocalStorageService,
    private licensingService: LicensingService,
    private toastrService: ToastrService,
    private addUpdateLicenseSliderModelService: AddUpdateLicenseSliderModelService,
    private commonService: CommonService,
    private activatedRoute: ActivatedRoute) {
  }

  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setLicenseDashoardHeight();
  }

  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setLicenseDashoardHeight();
  }

  // Set account table height
  setLicenseDashoardHeight() {
    const tableHeight = window.innerHeight - 65;
    $('.licenseLanding').css('height', tableHeight + 'px');

    const templateHeight = tableHeight - ($('.licenseTopSec').outerHeight()) - 65;
    $('.search-results').css('max-height', templateHeight + 'px');
  }

  // Set tile detail height
  setTileDetailHeight() {
    const tileHeight = $('.growerLicenseDetails').height() - 58;
    $('.orderDetails').css('height', tileHeight + 'px');
  }

  // Set tile height
  setTileHeight() {
    const divHeight = $('.growerLicenseDetails').height();
    $('.growerLicenseDetails').css('height', divHeight + 'px');
  }

  // Component Intilisation
  ngOnInit() {
    // Set the default value
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }
    if (this.localStorageService.get(MasterConstants.WF_Sales_GenericLevel)) {
      let salesGenericLevel = JSON.parse(this.localStorageService.get(MasterConstants.WF_Sales_GenericLevel));
      this.impDisplayName = salesGenericLevel.find(x => x.data == MasterConstants.WF_Impl_SplList_Display).value;
    }
    this.subscription.push(this.addUpdateLicenseSliderModelService.addUpdateLicenseModelData.subscribe(res => {
      if (res && res.saveLicense) {
        this.gmkList = [];
        this.redirectFromAddUpdate = true;
        this.getLicensingData();
      }
    }));

    this.subscription.push(this.commonService.getMessageConfiguration(MasterConstants.MESSAGE_GROWER_LICENSE_PAGE_WIP).subscribe(result => {
      if (result) {
        let messageConfiguration = result as MessageConfigurationVM;
        this.licensePageWIPMsg = messageConfiguration.message;
      }
    }, error => LolLoggerService.error(error)));

    this.getEvolveAccess();
    this.setSearchTypeList();
    this.resetLicensingFilter();
    this.initializeDeepLinkFilters();
    this.loadFiltersData();

    this.subscription.push(this.activatedRoute.paramMap.subscribe(() => {
      if (!this.licenseStatusList || this.licenseStatusList.length === 0) {
        return;
      }

      this.resetLicensingFilter();
      this.initializeDeepLinkFilters();
      this.preLoadFilters();
      this.getLicensingData();
    }));
  }

  initializeDeepLinkFilters() {
    this.deepLinkGrowerOrderNumber = (this.activatedRoute.snapshot.paramMap.get('growerOrderNumber') || '').trim() || null;
    this.deepLinkGrowerName = (this.activatedRoute.snapshot.paramMap.get('growerName') || '').trim() || null;
    this.deepLinkLicenseStatus = (this.activatedRoute.snapshot.paramMap.get('licenseStatus') || '').trim() || null;
    this.hasDeepLinkFilters = !!(this.deepLinkGrowerOrderNumber || this.deepLinkGrowerName || this.deepLinkLicenseStatus);
  }

  // Get evolve account restriction value
  getEvolveAccess() {
    this.readOnlyAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.LICENSE_EVOLVE);
  }

  // Set filter list based on evolve account restriction
  setSearchTypeList() {
    if (this.isEvolveAccountRestriction) {
      this.searchTypeList =
        [
          'License Status',
          'Trait Manufacturer',
          'Parent Account Number',
          'Account No',
          'Account City',
          'Account State',
          'Grower Name',
          'Grower City',
          'Grower State',
          'License Number',
          'Grower Order Number'
        ];
    } else {
      this.searchTypeList =
        [
          'License Status',
          'Trait Manufacturer',
          'Parent Account Number',
          'Account No',
          'Account Name',
          'Account City',
          'Account State',
          'Grower Name',
          'Grower City',
          'Grower State',
          'License Number',
          'Grower Order Number',
          this.impDisplayName,
          'SEL'
        ];
    }
    this.selectedValue = this.searchTypeList[0];
  }

  // Load Filter data
  loadFiltersData() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.licensingService.getLicensingFilters().subscribe(result => {
      this.accountStateList = (result.states || []).filter(x => x);
      this.growerStateList = (result.states || []).filter(x => x);
      this.accountsList = (result.accounts || []).filter(x => x);
      this.districtMasterList = (result.distDSM || []).filter(x => x);
      this.traitManufacturerList = (result.vendors || []).filter(x => x);
      this.licenseStatusList = (result.licenseStatus || []).filter(x => x && x.value);
      this.growerNameList = (result.growers || []).filter(x => x);
      this.selList = (result.sel || []).filter(x => x);

      const hasDeepLinkFilters = this.hasDeepLinkFilters;
      this.preLoadFilters();

      if (hasDeepLinkFilters) {
        this.getLicensingData();
      } else {
        this.loaderService.setLoaderStatus(false);
      }
    }, error => { this.loaderService.setLoaderStatus(false); }));
  }

  // Pre load default filters
  preLoadFilters() {
    if (this.hasDeepLinkFilters) {
      this.applyDeepLinkFilters();
      this.hasDeepLinkFilters = false;
      return;
    }

    if (this.productFilters.LicenseStatusList.length === 0) {
      let statusList = '';
      this.licensingFilter.licenseStatus = '';
      this.licenseStatusList.filter(f => f.id != 'L').map(m => {
        this.productFilters.LicenseStatusList.push(m.value);
        this.licensingFilter.licenseStatus += m.id + ',';
        statusList += m.value + ',';
        return m;
      });
      this.filterValueList.push('License Status : ' + statusList);
    }
  }

  applyDeepLinkFilters() {
    this.filterValueList = [];
    this.showAllLicences = false;
    this.licensingFilter.showAllLicences = false;

    if (this.deepLinkGrowerName && !this.deepLinkLicenseStatus && !this.deepLinkGrowerOrderNumber) {
      this.showAllLicences = true;
      this.licensingFilter.showAllLicences = true;
      this.productFilters.LicenseStatusList = [];
      this.licensingFilter.licenseStatus = null;
      this.productFilters.TxtGrowerName = this.deepLinkGrowerName;
      this.licensingFilter.growerName = this.deepLinkGrowerName;
      this.filterValueList.push('Grower Name : ' + this.deepLinkGrowerName);
      return;
    }

    const requestedStatus = (this.deepLinkLicenseStatus || 'Unlicensed').toLowerCase();
    const matchedStatus = this.licenseStatusList.find(item => item && item.value && item.value.toLowerCase() === requestedStatus)
      || this.licenseStatusList.find(item => item && item.id === 'U');

    this.productFilters.LicenseStatusList = [];
    if (matchedStatus && matchedStatus.value) {
      this.productFilters.LicenseStatusList = [matchedStatus.value];
      this.filterValueList.push('License Status : ' + matchedStatus.value);
      this.licensingFilter.licenseStatus = matchedStatus.id + ',';
    } else {
      this.filterValueList.push('License Status : Unlicensed');
      this.licensingFilter.licenseStatus = 'U,';
    }

    if (this.deepLinkGrowerOrderNumber) {
      this.productFilters.GrowerOrderNumber = this.deepLinkGrowerOrderNumber;
      this.licensingFilter.growerOrderNo = this.deepLinkGrowerOrderNumber;
      this.filterValueList.push('Grower Order Number : ' + this.deepLinkGrowerOrderNumber);
    } else if (this.deepLinkGrowerName) {
      this.productFilters.TxtGrowerName = this.deepLinkGrowerName;
      this.licensingFilter.growerName = this.deepLinkGrowerName;
      this.filterValueList.push('Grower Name : ' + this.deepLinkGrowerName);
    }
  }

  getLicenseStatus(licenseId) {
    const licenseStatus = this.licenseStatusList.find((item) => item.id === licenseId);
    return licenseStatus.value;
  }

  // Get licensing data
  getLicensingData() {
    this.loaderService.setLoaderStatus(true);

    // clear selected vendor
    this.backToList();

    this.subscription.push(this.licensingService.getLicensingList(this.licensingFilter).subscribe(result => {
      this.licensingList = result.growerLicenses;
      this.gmkList = result.gmKs;
      this.growerCount = result.growerCount;
      this.vendorMasterList = result.vendorMasters;
      if (result.growerCount > 100 && !this.redirectFromAddUpdate) {
        this.toastrService.warning('Results exceed 100, utilize the Email option to see a full list.');
      }
      else if (result.growerCount == 0) {
        this.toastrService.info('No record Found.');
      }
      this.redirectFromAddUpdate = false;
      this.unlicensedCount = this.licensingList.filter(x => x.licenseStatus !== null && x.isActive && x.licenseStatus !== 'L' && x.licenseStatus !== 'D').length;
      this.unauthorizedCount = this.licensingList.filter(x => x.licenseStatus !== null && x.isActive && x.licenseStatus === 'D').length;

      // Done so that templates get rendered properly
      setTimeout(x => {
        this.setLicenseDashoardHeight();
        this.setTileHeight();
        this.loaderService.setLoaderStatus(false);
      }, 1000);
    }, (error => {
      LolLoggerService.error(error);
      this.redirectFromAddUpdate = false;
      this.loaderService.setLoaderStatus(false);
    })));
  }

  // Get Licensing report via email
  getLicensingReport() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.licensingService.getLicensingReport(this.licensingFilter).subscribe(result => {
      this.toastrService.success('Your request is sent. You will get an email soon.');
      this.loaderService.setLoaderStatus(false);
    }, (error => {
      LolLoggerService.error(error);
      this.loaderService.setLoaderStatus(false);
    })));
  }

  // Get Licensing order detail if record is active
  getLicenseOrderDetail(vendor, grower, data) {
    const filter = {
      gmk: grower.gmk,
      growerOrderNo: data.growerOrderNumber
    };

    this.selectedGMK = {
      gmk: grower.gmk,
      vendor: vendor.value,
      licenseStatus: data.licenseStatus,
      licenseNumber: data.licenseNumber
    };

    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.licensingService.getLicensingOrderDetail(filter).subscribe(result => {
      if (result) {
        this.orderDetail = result;
        setTimeout(x => {
          this.setTileDetailHeight();
        }, 100);
      }
      this.loaderService.setLoaderStatus(false);
    }, (error => {
      LolLoggerService.error(error);
      this.loaderService.setLoaderStatus(false);
    })));
  }

  // Return true if there is a record for input gmk
  hasOrderByGmk(gmk: number) {
    return this.orderDetail.some(x => x.gmk == gmk);
  }

  // Clear order detail list on back click
  backToList() {
    this.orderDetail = [];
    this.selectedGMK = null;
  }
  // Get unlicensed count for vendor
  getVendorCount(item) {
    let count = 0;
    for (const index in this.gmkList) {
      const data = this.getGrowerLicenseDetail(this.gmkList[index], item.id);

      if (data && data.licenseStatus !== null && data.isActive && data.licenseStatus !== 'L') {
        count = count + 1;
      }
    }
    return count;
  }

  // Navigate to grower order
  redirectToOrder(order: any) {
    if (order.isPartnerOrder) {
      return false;
    }
    window.open('/orders/grower-order-detail' + '/0' + '/' + order.orderId, '_blank');
  }

  // Validate input text is number or not
  validateNumText(numInput) {
    const accountRegx = RegExp('^[0-9, ]+$');
    const isValidNumInput = accountRegx.test(numInput);
    if (!isValidNumInput) {
      this.toastrService.error('Invalid Input.');
      numInput = null;
    }
    return numInput;
  }

  // Validate input text for whole numeric and whole alphanumeric free from comma
  validateInput(numInput, checkNumericText) {
    let showToast = false;
    if (checkNumericText) {
      if (isNaN(+numInput)) {
        showToast = true;
      }
    } else {
      const accountRegx = RegExp('^[^,]+$');
      const isValidNumInput = accountRegx.test(numInput);
      if (!isValidNumInput) {
        showToast = true;
      }
    }

    if (showToast) {
      this.toastrService.error('Invalid Input.');
      numInput = null;
    }

    return numInput;
  }

  // Retain Filter Value
  retainFilter(selectedObj: any, type: string) {
    if (this.productFilters.ParentAccount) {
      this.productFilters.ParentAccount = this.validateInput(this.productFilters.ParentAccount, true);
    }
    if (this.productFilters.GrowerOrderNumber) {
      this.productFilters.GrowerOrderNumber = this.validateInput(this.productFilters.GrowerOrderNumber, true);
    }
    if (this.productFilters.TxtAccountNo) {
      this.productFilters.TxtAccountNo = this.validateNumText(this.productFilters.TxtAccountNo);
    }
    if (this.productFilters.AccountCity) {
      this.productFilters.AccountCity = this.validateInput(this.productFilters.AccountCity, false);
    }
    if (this.productFilters.GrowerCity) {
      this.productFilters.GrowerCity = this.validateInput(this.productFilters.GrowerCity, false);
    }
    if (this.productFilters.LicenseNumber) {
      this.productFilters.LicenseNumber = this.validateInput(this.productFilters.LicenseNumber, false);
    }

    if (this.filterValueList) {
      let selectedIds = '';
      if (selectedObj && selectedObj.selectedValues) {
        const selectedValues = selectedObj.selectedValues as any[];
        if (type === 'Grower Name') {
          selectedValues.forEach(x => { selectedIds = selectedIds + x.businessName + ','; });
        } else {
          selectedValues.forEach(x => { selectedIds = selectedIds + (type == 'AccountNo' ? x.accountNumber : x.id) + ','; });
        }
      }

      switch (type) {
        case 'Trait Manufacturer':
          this.licensingFilter.vendor = selectedIds;
          break;
        case 'Account State':
          this.licensingFilter.accountState = selectedIds;
          break;
        case 'Grower State':
          this.licensingFilter.growerState = selectedIds;
          break;
        case 'Grower Name':
          this.licensingFilter.growerName = selectedIds;
          break;
        case 'District':
          this.licensingFilter.dsm = selectedIds;
          break;
        case 'SEL':
          this.licensingFilter.sel = selectedIds;
          break;
        case 'License Status':
          this.licensingFilter.licenseStatus = selectedIds;
          break;
        case 'AccountNo':
          this.licensingFilter.accountNo = selectedIds;
          break;
      }

      // Create filterValueList from Product Filters
      this.filterValueList = [];

      // text Account No
      if (this.productFilters.TxtAccountNo && this.productFilters.TxtAccountNo != '') {
        this.filterValueList.push('Account No : ' + this.productFilters.TxtAccountNo);
        this.licensingFilter.accountNo = this.productFilters.TxtAccountNo;
      }
      else if (this.productFilters.AccountNo && this.productFilters.AccountNo.length > 0) {
        let strAct = '';
        this.productFilters.AccountNo.forEach(x => {
          strAct = strAct + x + ', ';
        });
        this.filterValueList.push('Account No : ' + strAct.substr(0, strAct.length - 2));

        this.licensingFilter.accountNo = strAct;
      }
      else {
        this.licensingFilter.accountNo = null;
      }

      // Account Name
      if (this.productFilters.AccountName && this.productFilters.AccountName != '') {
        this.filterValueList.push('Account Name : ' + this.productFilters.AccountName);
        this.licensingFilter.accountName = this.productFilters.AccountName;
      }
      else {
        this.licensingFilter.accountName = null;
      }

      if (this.productFilters.TraitManufacturerList && this.productFilters.TraitManufacturerList.length > 0) {
        let strVL = '';
        this.productFilters.TraitManufacturerList.forEach(x => {
          strVL = strVL + x + ', ';
        });
        this.filterValueList.push('Trait Manufacturer : ' + strVL.substr(0, strVL.length - 2));
      }

      if (this.productFilters.DistrictList && this.productFilters.DistrictList.length > 0) {
        let strD = '';
        this.productFilters.DistrictList.forEach(x => {
          strD = strD + x + ', ';
        });
        this.filterValueList.push(this.impDisplayName + ':' + strD.substr(0, strD.length - 2));
      }

      if (this.productFilters.SelNameList && this.productFilters.SelNameList.length > 0) {
        let strSEL = '';
        this.productFilters.SelNameList.forEach(x => {
          strSEL = strSEL + x + ', ';
        });
        this.filterValueList.push('SEL : ' + strSEL.substr(0, strSEL.length - 2));
      }

      if (this.productFilters.AccountStateList && this.productFilters.AccountStateList.length > 0) {
        let strAS = '';
        this.productFilters.AccountStateList.forEach(x => {
          strAS = strAS + x + ', ';
        });
        this.filterValueList.push('Account State : ' + strAS.substr(0, strAS.length - 2));
      }

      if (this.productFilters.GrowerStateList && this.productFilters.GrowerStateList.length > 0) {
        let strGS = '';
        this.productFilters.GrowerStateList.forEach(x => {
          strGS = strGS + x + ', ';
        });
        this.filterValueList.push('Grower State : ' + strGS.substr(0, strGS.length - 2));
      }

      if (this.productFilters.TxtGrowerName && this.productFilters.TxtGrowerName != '') {
        this.filterValueList.push('Grower Name : ' + this.productFilters.TxtGrowerName);
        this.licensingFilter.growerName = this.productFilters.TxtGrowerName;
      } else if (this.productFilters.GrowerNameList && this.productFilters.GrowerNameList.length > 0) {
        let strGN = '';
        this.productFilters.GrowerNameList.forEach(x => {
          strGN = strGN + x + ', ';
        });
        this.filterValueList.push('Grower Name : ' + strGN.substr(0, strGN.length - 2));
      }
      else {
        this.licensingFilter.growerName = null;
      }

      if (this.productFilters.LicenseStatusList && this.productFilters.LicenseStatusList.length > 0) {
        let strLS = '';
        this.productFilters.LicenseStatusList.forEach(x => {
          strLS = strLS + x + ', ';
        });
        this.filterValueList.push('License Status : ' + strLS.substr(0, strLS.length - 2));
      }

      // LicenseNumber
      if (this.productFilters.LicenseNumber && this.productFilters.LicenseNumber != '') {
        this.filterValueList.push('License Number : ' + this.productFilters.LicenseNumber);
        this.licensingFilter.licenseNumber = this.productFilters.LicenseNumber;
      }
      else {
        this.licensingFilter.licenseNumber = null;
      }

      // Account City
      if (this.productFilters.AccountCity && this.productFilters.AccountCity != '') {
        this.filterValueList.push('Account City : ' + this.productFilters.AccountCity);
        this.licensingFilter.accountCity = this.productFilters.AccountCity;
      }
      else {
        this.licensingFilter.accountCity = null;
      }

      // Grower City
      if (this.productFilters.GrowerCity && this.productFilters.GrowerCity != '') {
        this.filterValueList.push('Grower City : ' + this.productFilters.GrowerCity);
        this.licensingFilter.growerCity = this.productFilters.GrowerCity;
      }
      else {
        this.licensingFilter.growerCity = null;
      }

      // Grower Order Number
      if (this.productFilters.GrowerOrderNumber && this.productFilters.GrowerOrderNumber != '') {
        this.filterValueList.push('Grower Order Number : ' + this.productFilters.GrowerOrderNumber);
        this.licensingFilter.growerOrderNo = this.productFilters.GrowerOrderNumber;
      }
      else {
        this.licensingFilter.growerOrderNo = null;
      }

      // Parent Account Number
      if (this.productFilters.ParentAccount && this.productFilters.ParentAccount != '') {
        this.filterValueList.push('Parent Account Number : ' + this.productFilters.ParentAccount);
        this.licensingFilter.parentAccountNo = this.productFilters.ParentAccount;
      }
      else {
        this.licensingFilter.parentAccountNo = null;
      }
    }
  }

  // Reset Licensing Filter
  resetLicensingFilter() {
    this.productFilters = {
      'AccountNo': [],
      'AccountName': null,
      'TxtAccountNo': null,
      'TraitManufacturerList': [],
      'LicenseStatusList': [],
      'LicenseNumber': null,
      'AccountCity': null,
      'AccountStateList': [],
      'DistrictList': [],
      'SelNameList': [],
      'GrowerCity': null,
      'ParentAccount': null,
      'TxtGrowerName': null,
      'GrowerNameList': [],
      'GrowerOrderNumber': null,
      'GrowerStateList': []
    };

    this.licensingFilter = {
      'accountNo': null,
      'accountName': null,
      'txtAccountNo': null,
      'vendor': null,
      'licenseNumber': null,
      'licenseStatus': null,
      'accountCity': null,
      'accountState': null,
      'dsm': null,
      'sel': null,
      'growerCity': null,
      'parentAccountNo': null,
      'growerName': null,
      'growerOrderNo': null,
      'growerState': null,
      'showAllLicences': this.showAllLicences
    };
  }

  changeShowAllLicences(event) {
    this.licensingFilter.showAllLicences = this.showAllLicences;
  }

  // Clear filter
  clearFilter(filterValue) {
    const index = this.filterValueList.indexOf(filterValue);

    if (index > -1) {
      this.filterValueList.splice(index, 1);
      // remove Licensing filter
      this.removeLicensingFilter(filterValue);
    }
  }

  // To remove clear search filter
  removeLicensingFilter(filterValue) {
    const removeFilter = filterValue.split(' : ');
    const index = -1;
    switch (removeFilter[0].trim()) {
      case 'Trait Manufacturer':
        this.productFilters.TraitManufacturerList = [];
        this.licensingFilter.vendor = null;
        break;
      case 'Account No':
        this.productFilters.TxtAccountNo = null;
        this.productFilters.AccountNo = [];
        this.licensingFilter.accountNo = null;
      case 'Account Name':
        this.productFilters.AccountName = null;
        this.licensingFilter.accountName = null;
        break;
      case 'Account City':
        this.productFilters.AccountCity = null;
        this.licensingFilter.accountCity = null;
        break;
      case 'Account State':
        this.productFilters.AccountStateList = [];
        this.licensingFilter.accountState = null;
        break;
      case 'Grower City':
        this.productFilters.GrowerCity = null;
        this.licensingFilter.growerCity = null;
        break;
      case 'Grower Name':
        this.productFilters.GrowerNameList = [];
        this.productFilters.TxtGrowerName = null;
        this.licensingFilter.growerName = null;
        break;
      case 'Grower Order Number':
        this.productFilters.GrowerOrderNumber = null;
        this.licensingFilter.growerOrderNo = null;
        break;
      case 'Parent Account Number':
        this.productFilters.ParentAccount = null;
        this.licensingFilter.parentAccountNo = null;
        break;
      case 'Grower State':
        this.productFilters.GrowerStateList = [];
        this.licensingFilter.growerState = null;
        break;
      case 'License Number':
        this.productFilters.LicenseNumber = null;
        this.licensingFilter.licenseNumber = null;
        break;
      case 'License Status':
        this.productFilters.LicenseStatusList = [];
        this.licensingFilter.licenseStatus = null;
        break;
      case 'District':
        this.productFilters.DistrictList = [];
        this.licensingFilter.dsm = null;
        break;
      case 'SEL':
        this.productFilters.SelNameList = [];
        this.licensingFilter.sel = null;
        break;
      default:
        break;
    }
  }

  // Clear all filter
  clearAllFilter() {
    this.filterValueList = new Array();
    this.resetLicensingFilter();
    this.selectedValue = this.searchTypeList[0];
    this.gmkList = [];
    this.preLoadFilters();
  }

  // Search the account details on Account dropdown
  accountSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.accountName.toLocaleLowerCase().indexOf(term) > -1
      || item.accountNumber.toString().indexOf(term) > -1
      || item.address1.toLocaleLowerCase().indexOf(term) > -1
      || item.city.toLocaleLowerCase().indexOf(term) > -1
      || item.state.toLocaleLowerCase().indexOf(term) > -1
      || item.zipCode.toLocaleLowerCase().indexOf(term) > -1;
  }

  // Search the grower details on Grower dropdown
  growerSearchFn(term: string, item: any) {
    if (term) {
      term = term.toLocaleLowerCase();
    }
    return (item.businessName == null ? false : item.businessName.toLocaleLowerCase().indexOf(term) > -1)
      || (item.firstName == null ? false : item.firstName.toString().indexOf(term) > -1)
      || (item.lastName == null ? false : item.lastName.toString().indexOf(term) > -1)
      || (item.middleName == null ? false : item.middleName.toString().indexOf(term) > -1)
      || (item.gmk == null ? false : item.gmk.toString().indexOf(term) > -1)
      || (item.address1 == null ? false : item.address1.toLocaleLowerCase().indexOf(term) > -1)
      || (item.city == null ? false : item.city.toLocaleLowerCase().indexOf(term) > -1)
      || (item.state == null ? false : item.state.toLocaleLowerCase().indexOf(term) > -1)
      || (item.zip == null ? false : item.zip.toLocaleLowerCase().indexOf(term) > -1)
      || (item.primaryPhoneNumber == null ? false : item.primaryPhoneNumber.toLocaleLowerCase().indexOf(term) > -1);
  }

  // Open slider for license add/update/delete and load the data
  addUpdateLicense(item) {
    let totalCount = 0;
    let requiredCount = 0;
    const vendorLicense = this.vendorMasterList.map(x => {
      const grower = this.getGrowerLicenseDetail(item.gmk, x.id);
      if (grower && grower.licenseStatus !== null) {
        totalCount = totalCount + 1;
        if (grower.licenseStatus === 'L') {
          requiredCount = requiredCount + 1;
        }
        return {
          licenseStatus: grower.licenseStatus,
          licenseStatusFull: this.getLicenseStatus(grower.licenseStatus),
          manufacturer: x.value,
          licenseNumber: grower.licenseNumber,
          vendorId: x.id,
          growerLicenseId: grower.growerLicenseId
        };
      } else {
        return {
          licenseStatus: null,
          licenseStatusFull: null,
          manufacturer: x.value,
          licenseNumber: null,
          vendorId: x.id,
          growerLicenseId: 0
        };
      }
    });
    let requiredData = '0/0';
    if (totalCount) {
      requiredData = requiredCount + '/' + totalCount;
    }
    const data = {
      grower: item,
      licenseList: vendorLicense,
      required: requiredData
    };
    this.licensingService.setLicenseInfoData(data);
    this.addUpdateLicenseSliderModelService.activeSlider('AddUpdateLicenseSlider');
  }

  // Get grower details based on gmk no
  getGrowerList(gmk) {
    return this.licensingList.filter(s => s.gmk == gmk)[0];
  }

  // Get grower license detail based on vendor Id
  getGrowerLicenseDetail(gmk, vendorId) {
    return this.licensingList.filter(s => s.gmk == gmk && s.vendorId == vendorId)[0];
  }

  // Get required licenses count
  getRequired(item) {
    let total = 0;
    let required = 0;
    const vendorLicense = this.vendorMasterList.map(x => {
      const grower = this.getGrowerLicenseDetail(item, x.id);
      if (grower && grower.licenseStatus !== null && grower.isActive) {
        total = total + 1;
        if (grower.licenseStatus === 'L') {
          required = required + 1;
        }
      }
    });
    if (total) {
      return required + '/' + total;
    }
    return '0/0';
  }

  // On destroy of component
  ngOnDestroy() {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }
}
